/* eslint-disable camelcase */
import { DEFAULT_AGGREGATION_RES_LEVEL_H3 } from "../constants.js";
import { baseSource } from "./base-source.js";
export const h3TableSource = async function (options) {
    const { aggregationExp, aggregationResLevel = DEFAULT_AGGREGATION_RES_LEVEL_H3, spatialDataColumn = 'h3', tableName, filters } = options;
    const urlParameters = {
        aggregationExp,
        name: tableName,
        spatialDataColumn,
        spatialDataType: 'h3'
    };
    if (aggregationResLevel) {
        urlParameters.aggregationResLevel = String(aggregationResLevel);
    }
    if (filters) {
        urlParameters.filters = filters;
    }
    return baseSource('table', options, urlParameters);
};
